import loginImg from "../../assets/image/login.jpg";
import Template from "../../components/Auth/Template";
import "./Login.css";

function Login() {
  return (
    <div className="login-container">
      <Template
        title="Welcome Back"
        description1="Manage your events effortlessly, all in one place."
        description2="Plan, organize, and execute events seamlessly."
        image={loginImg}
        formType="login"
      />
    </div>
  );
}

export default Login;
